import * as UI from 'constants/ui';

export interface UiState {
  userIsTabbing: boolean;
}

const initialState: UiState = {
  userIsTabbing: false,
};

export default function ui(
  state: UiState = initialState,
  action: { type: string; payload?: unknown },
): UiState {
  switch (action.type) {
    case UI.SET_USER_IS_TABBING:
      return { ...state, userIsTabbing: true };
    case UI.UNSET_USER_IS_TABBING:
      return { ...state, userIsTabbing: false };
    default:
      return state;
  }
}
